import { Injectable, signal } from '@angular/core';
import { MenuChangeEvent } from './api/menuchangeevent';

@Injectable({
    providedIn: 'root'
})
export class MenuService {
    readonly menuChange = signal<MenuChangeEvent | null>(null);

    onMenuStateChange(event: MenuChangeEvent) {
        this.menuChange.set({ ...event });
    }

    reset() {
        this.menuChange.set(null);
    }
}
